/* EKDO Life v2: interactions for EKDO sections. No dependencies. */
(function () {
  'use strict';
  if (window.__ekdo) return;
  window.__ekdo = true;
  document.documentElement.classList.add('ek-js');

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- money ---------- */
  function money(paise) {
    var n = Math.round(Number(paise) / 100);
    return '₹' + n.toLocaleString('en-IN');
  }

  /* ---------- scroll reveal ---------- */
  function initReveal(root) {
    var els = root.querySelectorAll('[data-ek-reveal]:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduceMotion) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- rails: arrows, dots, autoplay ---------- */
  function initRail(wrap) {
    if (wrap.__ek) return; wrap.__ek = true;
    var rail = wrap.querySelector('.ek-rail, .ek-tiles');
    if (!rail) return;
    var prev = wrap.querySelector('[data-ek-prev]');
    var next = wrap.querySelector('[data-ek-next]');
    var dots = wrap.querySelector('.ek-dots');
    var items = Array.prototype.slice.call(rail.children);

    function step() {
      var first = items[0];
      if (!first) return rail.clientWidth;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    function maxScroll() { return rail.scrollWidth - rail.clientWidth - 2; }
    function index() { return Math.round(rail.scrollLeft / step()); }
    function update() {
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= maxScroll();
      if (dots) {
        var i = index();
        Array.prototype.forEach.call(dots.children, function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      }
    }
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });

    if (dots) {
      dots.innerHTML = '';
      items.forEach(function (_, k) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ek-dot';
        b.setAttribute('aria-label', 'Go to slide ' + (k + 1));
        b.addEventListener('click', function () { rail.scrollTo({ left: k * step(), behavior: 'smooth' }); });
        dots.appendChild(b);
      });
      if (items.length < 2) dots.hidden = true;
    }

    var t; rail.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(update, 60); }, { passive: true });
    window.addEventListener('resize', update);
    update();

    var auto = parseInt(wrap.getAttribute('data-ek-autoplay'), 10);
    if (auto > 0 && items.length > 1 && !reduceMotion) {
      var timer, paused = false;
      var tick = function () {
        if (paused || document.hidden) return;
        var i = index() + 1;
        rail.scrollTo({ left: i >= items.length ? 0 : i * step(), behavior: 'smooth' });
      };
      var start = function () { clearInterval(timer); timer = setInterval(tick, auto * 1000); };
      ['pointerenter', 'focusin', 'touchstart'].forEach(function (ev) { wrap.addEventListener(ev, function () { paused = true; }, { passive: true }); });
      ['pointerleave', 'focusout'].forEach(function (ev) { wrap.addEventListener(ev, function () { paused = false; }); });
      start();
    }
  }

  /* ---------- click-to-play videos (statement, feature, ritual) ---------- */
  function initVideo(box) {
    if (box.__ek) return; box.__ek = true;
    var btn = box.querySelector('[data-ek-play]');
    var vid = box.querySelector('video');
    var tpl = box.querySelector('template');
    if (!btn) return;
    btn.addEventListener('click', function () {
      if (tpl && !box.querySelector('iframe')) {
        box.appendChild(tpl.content.cloneNode(true));
        box.classList.add('is-playing');
        return;
      }
      if (!vid) return;
      vid.muted = false;
      vid.controls = true;
      vid.loop = false;
      vid.currentTime = 0;
      var p = vid.play(); if (p && p.catch) p.catch(function () {});
      box.classList.add('is-playing');
    });
  }

  /* ---------- background loops: only play while on screen ---------- */
  var loopIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (v.closest('.is-playing') && !v.closest('.ek-reel')) return;
      if (e.isIntersecting && !reduceMotion) {
        if (v.preload === 'none') v.preload = 'metadata';
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      } else if (!e.isIntersecting) { v.pause(); }
    });
  }, { threshold: 0.35 }) : null;
  function initLoops(root) {
    root.querySelectorAll('video[data-ek-loop]').forEach(function (v) {
      if (v.__ek) return; v.__ek = true;
      v.muted = true; v.playsInline = true;
      if (loopIO) loopIO.observe(v);
    });
  }

  /* ---------- reels: tap toggles sound on one reel at a time ---------- */
  function initReel(reel) {
    if (reel.__ek) return; reel.__ek = true;
    var v = reel.querySelector('video');
    if (!v) return;
    reel.classList.add('is-playing');
    function toggle(e) {
      e.preventDefault();
      var turnOn = v.muted;
      document.querySelectorAll('.ek-reel.is-unmuted').forEach(function (r) {
        var o = r.querySelector('video'); if (o) o.muted = true; r.classList.remove('is-unmuted');
      });
      v.muted = !turnOn;
      if (turnOn) { reel.classList.add('is-unmuted'); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    }
    var media = reel.querySelector('.ek-reel__media');
    if (media) {
      media.addEventListener('click', toggle);
      media.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') toggle(e); });
    }
  }

  /* ---------- accordions: optional one-open-at-a-time ---------- */
  function initAcc(acc) {
    if (acc.__ek) return; acc.__ek = true;
    if (!acc.hasAttribute('data-ek-single')) return;
    acc.addEventListener('toggle', function (e) {
      if (!e.target.open) return;
      acc.querySelectorAll('details[open]').forEach(function (d) { if (d !== e.target) d.open = false; });
    }, true);
  }

  /* ---------- product cards: variant switch + AJAX add to cart ---------- */
  function initCard(form) {
    if (form.__ek) return; form.__ek = true;
    var sel = form.querySelector('select[name="id"]');
    var card = form.closest('[data-ek-card]') || form;
    var btn = form.querySelector('.ek-atc');
    var label = btn ? btn.querySelector('span') : null;
    var addText = label ? label.textContent : '';

    function sync() {
      if (!sel) return;
      var o = sel.options[sel.selectedIndex];
      var price = +o.getAttribute('data-price');
      var compare = +o.getAttribute('data-compare') || 0;
      var now = card.querySelector('[data-ek-now]');
      var was = card.querySelector('[data-ek-was]');
      var off = card.querySelector('[data-ek-off]');
      if (now) now.textContent = money(price);
      if (was) { was.textContent = compare > price ? money(compare) : ''; }
      if (off) { off.textContent = compare > price ? Math.round((compare - price) * 100 / compare) + '% OFF' : ''; }
      var img = o.getAttribute('data-img');
      var first = card.querySelector('.ek-card__media img');
      if (img && first) { first.srcset = ''; first.src = img; }
      if (btn) {
        var ok = o.getAttribute('data-available') === 'true';
        btn.disabled = !ok;
        if (label) label.textContent = ok ? addText : (btn.getAttribute('data-soldout') || 'Sold out');
      }
    }
    if (sel) { sel.addEventListener('change', sync); sync(); }

    form.addEventListener('submit', function (e) {
      if (!window.fetch || !btn) return;
      e.preventDefault();
      btn.classList.add('is-loading');
      addToCart(form).then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        if (label) label.textContent = btn.getAttribute('data-added') || 'Added';
        setTimeout(function () { btn.classList.remove('is-added'); if (label) label.textContent = addText; }, 1800);
      }).catch(function (err) {
        btn.classList.remove('is-loading');
        toast((err && err.message) || 'Could not add to cart', false);
      });
    });
  }

  function addToCart(form) {
    var fd = new FormData(form);
    var drawer = document.querySelector('cart-drawer');
    var notif = document.querySelector('cart-notification');
    var target = drawer || notif;
    var sections = [];
    if (target && typeof target.getSectionsToRender === 'function') {
      sections = target.getSectionsToRender().map(function (s) { return s.id; });
    }
    if (sections.length) {
      fd.append('sections', sections.join(','));
      fd.append('sections_url', window.location.pathname);
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: fd
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) throw new Error(res.description || res.message);
      if (target && typeof target.renderContents === 'function' && res.sections) {
        target.renderContents(res);
        if (drawer) drawer.classList.remove('is-empty');
      } else {
        refreshBubble();
        toast('Added to cart', true);
      }
      document.dispatchEvent(new CustomEvent('ek:cart:added', { detail: res }));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      return res;
    });
  }

  function refreshBubble() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-cart-count], .cart-count-bubble span[aria-hidden]').forEach(function (n) { n.textContent = c.item_count; });
    }).catch(function () {});
  }

  var toastEl;
  function toast(msg, withLink) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'ek-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '';
    var s = document.createElement('span'); s.textContent = msg; toastEl.appendChild(s);
    if (withLink) { var a = document.createElement('a'); a.href = '/cart'; a.textContent = 'View cart'; toastEl.appendChild(a); }
    requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    clearTimeout(toastEl.__t);
    toastEl.__t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  }


  /* ---------- before / after slider ---------- */
  function initBA(box) {
    if (box.__ek) return; box.__ek = true;
    var range = box.querySelector('.ek-ba__range');
    if (!range) return;
    var set = function () { box.style.setProperty('--pos', range.value + '%'); };
    range.addEventListener('input', set);
    set();
  }

  /* ---------- results: count up + fill rings when visible ---------- */
  function initResults(sec) {
    if (sec.__ek) return; sec.__ek = true;
    var rings = sec.querySelectorAll('.ek-ring');
    var run = function () {
      rings.forEach(function (r) {
        var target = parseFloat(r.getAttribute('data-value')) || 0;
        var pct = Math.min(100, parseFloat(r.getAttribute('data-pct')) || target);
        var out = r.querySelector('[data-count]');
        r.style.setProperty('--p', pct);
        if (!out || reduceMotion) { if (out) out.textContent = target; return; }
        var t0 = null, dur = 1400;
        var step = function (ts) {
          if (!t0) t0 = ts;
          var k = Math.min(1, (ts - t0) / dur);
          var e = 1 - Math.pow(1 - k, 3);
          out.textContent = Math.round(target * e);
          if (k < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      });
    };
    if (!('IntersectionObserver' in window)) return run();
    var io = new IntersectionObserver(function (en) {
      if (en.some(function (e) { return e.isIntersecting; })) { run(); io.disconnect(); }
    }, { threshold: 0.3 });
    io.observe(sec);
  }

  /* ---------- boot ---------- */
  function init(root) {
    root = root || document;
    initReveal(root);
    initLoops(root);
    root.querySelectorAll('[data-ek-rail]').forEach(initRail);
    root.querySelectorAll('[data-ek-video]').forEach(initVideo);
    root.querySelectorAll('.ek-reel').forEach(initReel);
    root.querySelectorAll('.ek-acc').forEach(initAcc);
    root.querySelectorAll('form[data-ek-form]').forEach(initCard);
    root.querySelectorAll('.ek-ba__slider').forEach(initBA);
    root.querySelectorAll('[data-ek-results]').forEach(initResults);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  /* Re-run when a section is added or edited in the theme editor */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target; var rail = el.closest('.ek-rail');
    if (rail) rail.scrollTo({ left: el.offsetLeft - rail.offsetLeft, behavior: 'smooth' });
  });

  window.EKDO = { init: init, money: money, toast: toast };
})();
